import '@styles/components/appCiviStationconStru.less';

const NewOne = () => {
  return (
    <div className={'app-display-desc'}>
      <div className={'padding-top'}>
        <div className={'content-title'}>
          <p className={'text'}>
            支持铁路BIM标准的施工模型深化及应用BIM软件及二次开发技术交流大会回顾
          </p>
        </div>
        <div className={'content-introduction'}>
          <p>
            在全球数字化的浪潮中，国际铁路联盟发布实施由我国主持制定的《高速铁路设计基础设施》标准和《高速铁路设计供电》标准为相关领域数字化转型提供准则。纵观整个基础设施领域，BIM技术作为链接BIM数智世界的基础，正悄然改变传统基建，赋能工程建设全产业链，而BIM软件的二次开发将进一步促进BIM技术研发与落地应用。
          </p>
          <p>
            为加强BIM技术交流合作，7月20日与21日上午，铁路BIM联盟和中国铁道学会信息化委员会共同主办了“云端荟萃，筑基数智——BIM软件及二次开发技术交流大会”，本次大会汇聚软件公司、设计院、施工企业等领域权威专家跨界交流，得到业内人士的一致认可与热情反馈。
          </p>
        </div>
        <div className={'csc-text'}>精彩直播摘要</div>
        <div className={'content-introduction'}>
          7月21日上午，跨世纪项目研发部总经理崔杨带来题为《支持铁路BIM标准的施工模型深化及应用》的精彩演讲，本次技术交流会主要围绕：铁路BIM标准解读、设计模型&施工模型、数字孪生与智能制造、解决方案及未来规划四个方向进行讲解，分享了跨世纪关于BIM软件二次开发的观点、技术和落地应用价值。
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <p className={'text'}>铁路BIM标准解读</p>
          <span className={'line'} />
        </div>
        <div className={'text-center margin5'}>
          <img className={'csc'} src={require('@images/common/new_01.jpg').default} alt="" />
          <p className={'qldsimgj'}></p>
        </div>
        <div className={'margin5'}></div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>设计模型&施工模型</p>
          <span className={'line'} />
        </div>
        <div className={'introduce'}>
          解决设计BIM模型到施工BIM模型的转换是BIM推广应用的关键之一。
        </div>
        <div className={'csc-text'}>存在的问题：</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>设计BIM模型来自于多种建模软件，多种格式互不兼容</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>施工单位建模工具软件有限，掌握的人员有限</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>设计BIM模型交付给施工单位时无完整的工程结构关系信息</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>设计BIM模型的颗粒度及属性和施工BIM模型的不一致</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>施工阶段需对模型进一步细化</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>施工阶段需要模型的完整结构和编码信息</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>施工阶段模型存在变更，需要同步关联信息</span>
          </div>
        </div>

        <div className={'text-center margin-top'}>
          <img className={'csc'} src={require('@images/common/new_02.jpg').default} alt="" />
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <p className={'text'}>基于数字孪生的梁场设计与生产管理。</p>
          <span className={'line'} />
        </div>
        <div className={'csc-text'}>CivilStation Construction—智能建造：</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>自动排产</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>支持固定台座、移动台座</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>数字孪生模型关联生产信息和资产信息</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>生产组织及预警</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>架梁与制梁双模管理</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>项目及模型自维护，降低复用成本和难度</span>
          </div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>支持铁路及公路标准梁片</span>
          </div>
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>解决方案与未来规划</p>
          <span className={'line'} />
        </div>
        <div className={'introduce'}>解决设计模型转换问题。</div>
        <div className={'text-center margin-top'}>
          <img className={'ql_02'} src={require('@images/common/new_03.jpg').default} alt="" />
        </div>
        <div className={'introduce'}>
          详细讲解请点击链接：
          <a href={'https://xlo.h5.xeknow.com/s/2EWP5M'}>https://xlo.h5.xeknow.com/s/2EWP5M</a>
        </div>
      </div>
    </div>
  );
};

export default NewOne;
